export default __webpack_public_path__ + "locales/hy-AM/Payments.json?hash=04d39fb16cee5265f086a27cc77f684f";